<template>
<div class="kt-forecast-project-information">
	<div class="rf-project-info-bulk">
		<span class="rf-project-info-bulk-lbl">All Projects</span>
		<div class="rf-project-info-bulk-fields">
			<div class="rf-project-info-bulk-field">
				<label>Curve Method</label>
				<b-form-select
					size="sm"
					v-model="d_bulkCurveMethod"
					:options="CURVE_METHOD_OPTIONS"
				/>
			</div>
			<div class="rf-project-info-bulk-field">
				<label>S-Curve Steepness</label>
				<b-form-select
					size="sm"
					v-model="d_bulkSCurveSteepness"
					:options="S_CURVE_STEEPNESS_OPTIONS"
					:disabled="d_bulkCurveMethod !== 'scurve'"
				/>
			</div>
			<b-button
				variant1="outline-secondary"
				variant2="none"
				size="sm"
				class="rf-project-info-bulk-btn"
				@click="m_applyCurveToAll"
			>
				Apply to All Projects
			</b-button>
		</div>
	</div>

	<div class="rf-project-info-list">
		<kt-project-forecast
			v-for="(proj, ix) in projects"
			:key="proj.id"
			embedded
			:project="proj"
			:color="c_projectColor(ix)"
			:retainage-pct="retainagePct"
			:payment-lag-days="paymentLagDays"
			:gross-margin-pct="grossMarginPct"
			@update:project="m_updateProject(ix, $event)"
			@updateBusinessInsight="m_updateBusinessInsight"
		/>
	</div>
</div>
</template>

<script>
import KTProjectForecast from '@/components/Ctrl/KT-ProjectForecast.vue';
import {
	PROJECT_COLORS,
	CURVE_METHOD_OPTIONS,
	S_CURVE_STEEPNESS_OPTIONS,
	fn_forecastEndDate,
} from '@/utils/forecastUtils.js';

export default {
	name: 'kt-forecast-project-information',
	components: {
		'kt-project-forecast': KTProjectForecast,
	},
	props: {
		projects: {
			type: Array,
			required: true,
			default:[]
		},
		retainagePct: { type: Number, default: 0 },
		paymentLagDays: { type: Number, default: 0 },
		grossMarginPct: { type: Number, default: 0 },
	},
	data() {
		return {
			CURVE_METHOD_OPTIONS,
			S_CURVE_STEEPNESS_OPTIONS,
			d_bulkCurveMethod: 'scurve',
			d_bulkSCurveSteepness: 8,
		};
	},
	watch: {
		projects: {
			immediate: true,
			handler(projects) {
				console.log('projects watch in kt-forecast-project-information',projects);
				if (!projects || !projects.length) return;
				const methods = [...new Set(projects.map(p => p.curveMethod))];
				if (methods.length === 1) {
					this.d_bulkCurveMethod = methods[0];
				}
				const steepness = [...new Set(projects.map(p => p.sCurveSteepness))];
				if (steepness.length === 1) {
					this.d_bulkSCurveSteepness = steepness[0];
				}
			},
		},
	},
	methods: {
		c_projectColor(ix) {
			return PROJECT_COLORS[ix % PROJECT_COLORS.length];
		},
		m_emitProjects(next) {
			this.$emit('change', next.map(p => ({ ...p })));
		},
		m_normalizeProject(project) {
			const next = { ...project };
			if (next.startDate) {
				next.startDateFull = `${next.startDate}-01`;
			}
			next.endDate = fn_forecastEndDate(next);
			return next;
		},
		m_applyCurveToAll() {
			const curveMethod = this.d_bulkCurveMethod;
			const sCurveSteepness = Number(this.d_bulkSCurveSteepness) || 8;
			this.m_emitProjects(this.projects.map(p => this.m_normalizeProject({
				...p,
				curveMethod,
				sCurveSteepness,
			})));
			
			this.projects.forEach(p=>{
			               this.$emit('updateBusinessInsight',{record:p.id,recordType:p.recordType,field:'curveMethod',value:curveMethod});
						   this.$emit('updateBusinessInsight',{record:p.id,recordType:p.recordType,field:'sCurveSteepness',value:sCurveSteepness});
						   });
			
		},
		m_updateProject(ix, project) {
			const next = this.projects.map((p, i) => (
				i === ix ? this.m_normalizeProject(project) : p
			));
			this.m_emitProjects(next);
		},
		m_updateBusinessInsight(e){
			this.$emit('updateBusinessInsight',e);
		}
	},
};
</script>

<style lang="less" scoped>
.kt-forecast-project-information {
	font-size: 0.9em;
}

.rf-project-info-bulk1 {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 0.5em 1em;
	margin-bottom: 0.75em;
	padding: 0.5em 0.75em;
	background: #eef2f7;
	border: 1px solid #ced4da;
	border-radius: 0.25em;
}
.rf-project-info-bulk-btn {
        margin-bottom1: 20px;
        padding1: 10px 16px;
        background: #007bff;
        color: white;
        border-radius: 6px;
        border: none;
        font-size: 14px;
        cursor: pointer;
    }
.rf-project-info-bulk-btn:hover {
        color: white !important;
        background: #0069d9 !important;
}
.rf-project-info-bulk-lbl {
	font-weight: 600;
	font-size: 0.85em;
	color: #495057;
	margin-right: 0.25em;
}

.rf-project-info-bulk-fields {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	gap: 0.5em 1em;
	flex: 1;
}

.rf-project-info-bulk-field {
	min-width: 140px;

	label {
		display: block;
		font-size: 0.75em;
		font-weight: 600;
		margin-bottom: 0.15em;
		color: #495057;
	}
}

.rf-project-info-bulk-btn {
	margin-bottom: 1px;
}

.rf-project-info-list {
	max-height: 600px;
	overflow-y: auto;
}
</style>
